import {createBrowserRouter, Navigate} from "react-router-dom";
import {ShopLayout} from "@/layouts/ShopLayout";
import {AdminLayout, AdminLoginPage} from "@/layouts/AdminLayout";
import {HomePage} from "@/pages/HomePage";
import {AutentificarePage} from "@/pages/AutentificareForm";
import {PresentationPage} from "@/pages/PresentationPage";
import {CategoryPageClient} from "@/pages/CategoryPageClient";
import {ProductPageClient} from "@/pages/ProductPageClient";
import {BrandPageClient} from "@/pages/BrandPageClient";
import {DezabonarePageClient} from "@/pages/DezabonarePageClient";
import {CautarePage} from "@/pages/CautarePage";
import {AccountTabPage} from "@/pages/AccountTabPage";
import {AccountOrderDetailPage} from "@/pages/AccountOrderDetailPage";
import {DepartmentHubPage} from "@/pages/DepartmentHubPage";
import {CampaniePage} from "@/pages/CampaniePage";
import {LegacyOrNotFoundPage} from "@/pages/LegacyOrNotFoundPage";
import {ProductListPage, CmsSlugPage} from "@/pages/ProductListPage";
import {CartView} from "@/components/shop/CartView";
import {CheckoutView} from "@/components/shop/CheckoutView";
import {PaymentView} from "@/components/shop/PaymentView";
import {WishlistView} from "@/components/shop/WishlistView";
import {BrandListView} from "@/components/shop/BrandListView";
import {NoutatiView} from "@/components/shop/NoutatiView";
import {BestSellersView} from "@/components/shop/BestSellersView";
import {FaqView} from "@/components/shop/FaqView";
import {ContactView} from "@/components/shop/ContactView";
import {ReturnFormView} from "@/components/shop/ReturnFormView";
import {AccountShell} from "@/components/shop/AccountShell";
import {DesignSystemPage} from "@/pages/DesignSystemPage";
import {DashboardView} from "@/components/admin/DashboardView";
import {IntegrationsView} from "@/components/admin/IntegrationsView";
import {OrdersView} from "@/components/admin/OrdersView";
import {ReturnsView} from "@/components/admin/ReturnsView";
import {VouchersView} from "@/components/admin/VouchersView";
import {ProductsView} from "@/components/admin/ProductsView";
import {ProductOffersView} from "@/components/admin/ProductOffersView";
import {ProductReviewsView} from "@/components/admin/ProductReviewsView";
import {ProductShippingView} from "@/components/admin/ProductShippingView";
import {ClientsView} from "@/components/admin/ClientsView";
import {ClientGroupsView} from "@/components/admin/ClientGroupsView";
import {ClientNotificationsView} from "@/components/admin/ClientNotificationsView";
import {InfluencerRatesView} from "@/components/admin/InfluencerRatesView";
import {InfluencerPayoutsView} from "@/components/admin/InfluencerPayoutsView";
import {CmsPagesView} from "@/components/admin/CmsPagesView";
import {CmsHomeBoxesView} from "@/components/admin/CmsHomeBoxesView";
import {CmsCarouselView} from "@/components/admin/CmsCarouselView";
import {CmsAnnouncementsView} from "@/components/admin/CmsAnnouncementsView";
import {CmsFaqRefineView} from "@/components/admin/refine/CmsFaqRefineView";
import {SeoView} from "@/components/admin/SeoView";
import {UsersView} from "@/components/admin/UsersView";
import {LogView} from "@/components/admin/LogView";
import {SettingsView} from "@/components/admin/SettingsView";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ShopLayout />,
    children: [
      {index: true, element: <HomePage />},
      {path: "departments/:departmentId", element: <DepartmentHubPage />},
      {path: "login", element: <AutentificarePage />},
      {path: "presentation", element: <PresentationPage />},
      {path: "c/*", element: <CategoryPageClient />},
      {path: "p/:slug", element: <ProductPageClient />},
      {path: "brand/:id/:slug", element: <BrandPageClient />},
      {path: "brand/:slug", element: <BrandPageClient />},
      {path: "unsubscribe/:hash", element: <DezabonarePageClient />},
      {path: "search", element: <CautarePage />},
      {path: "cart", element: <CartView />},
      {path: "checkout", element: <CheckoutView />},
      {path: "payment", element: <PaymentView />},
      {path: "wishlist", element: <WishlistView />},
      {path: "brands", element: <BrandListView />},
      {path: "new", element: <NoutatiView />},
      {path: "all", element: <ProductListPage list="all" title="Toate produsele" />},
      {path: "promotions", element: <ProductListPage list="promotii" title="Promotii" />},
      {path: "best-sellers", element: <BestSellersView />},
      {path: "free-shipping", element: <ProductListPage list="transport-gratis" title="Transport gratuit" />},
      {path: "campaign", element: <CampaniePage />},
      {path: "faq", element: <FaqView />},
      {path: "design-system", element: <DesignSystemPage />},
      {path: "contact", element: <ContactView />},
      {path: "return-form", element: <ReturnFormView />},
      {path: "account", element: <AccountShell tab="" />},
      {path: "account/orders/:orderId", element: <AccountOrderDetailPage />},
      {path: "account/companies", element: <AccountShell tab="firme" />},
      {path: "account/:tab", element: <AccountTabPage />},
      {path: "payment-delivery", element: <CmsSlugPage slug="despre-plata-si-livrare" />},
      {path: "returns-policy", element: <CmsSlugPage slug="returnare-produse" />},
      {path: "terms", element: <CmsSlugPage slug="termeni-si-conditii" />},
      {path: "privacy", element: <CmsSlugPage slug="politica-de-confidentialitate" />},
      {path: "404", element: <LegacyOrNotFoundPage />},
      {path: "*", element: <LegacyOrNotFoundPage />}
    ]
  },
  {
    path: "/vadmin",
    element: <AdminLayout />,
    children: [
      {path: "login", element: <AdminLoginPage />},
      {index: true, element: <DashboardView />},
      {path: "integrari", element: <IntegrationsView />},
      {path: "comenzi", element: <OrdersView />},
      {path: "comenzi/returnare", element: <ReturnsView />},
      {path: "comenzi/vouchere", element: <VouchersView />},
      {path: "produse", element: <ProductsView />},
      {path: "produse/oferte", element: <ProductOffersView />},
      {path: "produse/recenzii", element: <ProductReviewsView />},
      {path: "produse/transport", element: <ProductShippingView />},
      {path: "clienti", element: <ClientsView />},
      {path: "clienti/grupuri", element: <ClientGroupsView />},
      {path: "clienti/notificari", element: <ClientNotificationsView />},
      {path: "clienti/influencer-rates", element: <InfluencerRatesView />},
      {path: "clienti/influencer-payouts", element: <InfluencerPayoutsView />},
      {path: "continut", element: <CmsPagesView />},
      {path: "continut/casute", element: <CmsHomeBoxesView />},
      {path: "continut/carusel", element: <CmsCarouselView />},
      {path: "continut/anunturi", element: <CmsAnnouncementsView />},
      {path: "continut/faq", element: <CmsFaqRefineView />},
      {path: "seo", element: <SeoView />},
      {path: "setari", element: <SettingsView />},
      {path: "utilizatori", element: <UsersView />},
      {path: "log", element: <LogView />},
      {path: "*", element: <Navigate to="/vadmin" replace />}
    ]
  }
]);
